import {CellData} from './cell-data';
import { GridRow} from './offerEntryData';

export class MessageData {
    level: string;
    portfolioId: string;
    key: string;
    name: string;
    subRow: number;
    details: CellData[] = [];

    constructor() { }

    public setData(level: string, portfolioId: string, key: string): void;
    public setData(level: string, portfolioId: string, gridRow: GridRow, subRow: number): void;
    public setData(level: string, portfolioId: string, param1?: any, param2?: any): void {
        this.level = level;
        this.portfolioId = portfolioId;
        if (param1) {
            if (param2) {
                this.key = param1.id;
                this.name = param1.name;
                this.subRow = param2;
            } else if (typeof param1 === 'string') {
                this.key = param1;
            } else if (typeof param1 === 'number') {
                this.key = param1.toString();
            }
        }
    }

    public addDetail(date: string, index: number, value: number) {
        const celldata = new CellData(date, index, value);
        this.details.push(celldata);
    }
}




// WEBPACK FOOTER //
// ./src/app/core/models/message-data.ts